import React from 'react';
import { MeetingRoomsSection } from './MeetingRoomsSection';

/**
 * VIS (Third Party Platform) settings — meeting room library only.
 * Legacy constant default fields were removed in favor of configurable meeting rooms.
 */
export function VISSettingsForm({ customerId }: { customerId: number }) {
  return (
    <div>
      <div className="mb-6">
        <h4 className="fw-bold text-gray-900 mb-2">Meeting Room Configuration</h4>
        <p className="text-muted mb-0">
          Pre-configure meeting rooms for this account. Project managers can select a room when creating VIS
          appointments so link, ID, and PIN are applied consistently.
        </p>
      </div>

      <MeetingRoomsSection customerId={customerId} />
    </div>
  );
}
